<template>
  <Offcanvas name="userEditOffcanvas">
    <template v-slot:header>
      <h4>ユーザーの編集</h4>
    </template>
    <template v-slot:default>
      <form @submit.prevent="update" v-if="editingUser">
        <UserForm v-model="editingUser" :is-edit="true" :current-admin-permissions="currentAdmin?.permissions || []"/>
        <div class="mt-3">
          <button class="btn btn-primary w-100">更新</button>
        </div>
      </form>
    </template>
  </Offcanvas>
</template>

<script setup>
import {onMounted, ref, watch} from 'vue';
import {useRouter} from 'vue-router';
import {updateUser} from '../../../api/admin/UserApi';
import {getCurrentAdmin} from '../../../api/admin/AuthApi';
import Offcanvas from '../../../components/Offcanvas.vue';
import useFlashMessage from '../../../composables/useFlashMessage';
import useOffcanvas from '../../../composables/useOffcanvas';
import User from '../../../models/User';
import UserForm from './UserForm.vue';

const props = defineProps({
  user: User
});

const emit = defineEmits(['update']);

const router = useRouter();
const {successMessage, errorMessage} = useFlashMessage();
const {closeOffcanvas} = useOffcanvas('userEditOffcanvas');

const editingUser = ref();
const currentAdmin = ref();

onMounted(async () => {
  currentAdmin.value = await getCurrentAdmin();
});

watch(props, () => editingUser.value = new User({...props.user}));

/**
 * ユーザーを更新
 *
 * @returns {Promise<void>}
 */
const update = async () => {
  // Check if current admin still has MANAGE permission
  const freshCurrentAdmin = await getCurrentAdmin();
  const hasManagePermission = freshCurrentAdmin.permissions?.some(p => p.permissionType === 'MANAGE');

  if (!hasManagePermission) {
    errorMessage('管理権限がないためデータを編集できません');
    return;
  }

  try {
    await updateUser(editingUser.value);
    successMessage('ユーザー「' + editingUser.value.name + '」を更新しました。');
    emit('update');
    closeOffcanvas();
  } catch (e) {
    errorMessage(e.message);
  }
};
</script>
